import http from '@/utils/http'

//评价管理列表
export function getAssessment(params) {
    return http({
      method: 'get',
      url: '/system/xcwsEntityAssessment/paging',
      params
    })
  }
  //删除评论
  export function delAssessment(params,entityId) {
    return http({
      method: 'post',
      url: `/system/xcwsEntityAssessment/delete/${entityId}`,
      data:params
    })
  }

  //修改评价标签
  export function addAssessmentTag(params) {
    return http({
      method: 'post',
      url: '/system/xcwsEntityAssessmentTag/update',
      data:params
    })
  }
  //查询评价标签
  export function getAssessmentTag() {
    return http({
      method: 'get',
      url: '/system/xcwsEntityAssessmentTag/find'
    })
  }